export default __webpack_public_path__ + "ee3fd6ce60d91d2df9bf98b5525a63e9.jpg";